import { animated, useInView } from "@react-spring/web"; // Import react-spring
import React, { HTMLAttributes } from "react";

interface ISectionTitle {
  chineseTitle: string;
  englishTitle: string;
}

type TSectionTitleProps = ISectionTitle & HTMLAttributes<HTMLDivElement>;

const SectionTitle: React.FC<TSectionTitleProps> = (props) => {
  const { chineseTitle, englishTitle, ...otherProps } = props;

  // Define the fade-in animation using useInView
  const [ref, springs] = useInView(() => ({
    from: { opacity: 0, transform: "translateY(50px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { tension: 200, friction: 40 },
    rootMargin: "-70%", // Trigger animation when the element is 40% in view
    once: true, // Trigger animation only once
  }));

  return (
    <animated.div
      ref={ref} // Attach the ref to the animated div
      style={springs} // Apply the animated styles
      className="flex flex-col gap-3 text-white font-extrabold justify-center items-center mb-3 laptop:mb-10 text-center"
      {...otherProps}
    >
      <div className="text-3xl laptop:text-6xl">{chineseTitle}</div>
      <div className="text-2xl laptop:text-5xl">{englishTitle}</div>
    </animated.div>
  );
};

export default SectionTitle;
